import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractCustomFormatInsights($customerId: ID!, $customFormatId: ID!, $html: String!) {
    extractCustomFormatInsights(
      customerId: $customerId
      customFormatId: $customFormatId
      html: $html
    ) {
      fixedText
      fixedHtml
      originalText
      violations {
        text
        explanation
      }
    }
  }
`;

export const extractCustomFormatInsights = async (
  { customerId, customFormatId, text, html },
  options
) => {
  const variables = {
    customerId,
    customFormatId,
    html,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
